export const PALETTES_IDS = [
    1, 2, 3, 4
]

export const CRATE_BOX_IDS = [
    1000, 1001
];

export const CRATE_ID = 1000;
export const BOX_ID = 1001;

